'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormField = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var FormField = function FormField(_ref) {
  var label = _ref.label,
      type = _ref.type,
      options = _ref.options,
      id = _ref.id,
      className = _ref.className,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      props = (0, _objectWithoutProperties3.default)(_ref, ['label', 'type', 'options', 'id', 'className', 'value', 'placeholder', 'onChange']);

  var isTextArea = type === 'textarea';
  var isSelect = type === 'select';
  var isDate = type === 'date';

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      labelTop = _useState2[0],
      setLabelTop = _useState2[1];

  var updateLabelStyle = function updateLabelStyle(el) {
    var value = el.target.value;

    if (value && value !== '') {
      setLabelTop(true);
    } else {
      setLabelTop(function (style) {
        return !style;
      });
    }
  };

  return _react2.default.createElement('label', (0, _extends3.default)({
    className: (0, _classnames2.default)(className, {
      'frm-Field': true,
      'frm-Field-noLabel': !label,
      'frm-Field-select': isSelect
    })
  }, props), isTextArea && _react2.default.createElement('textarea', {
    className: 'frm-Field_Item frm-Field_Item-textarea',
    id: id,
    value: value,
    placeholder: placeholder,
    onChange: onChange
  }), isSelect && _react2.default.createElement('select', { className: 'frm-Field_Item', id: id, onChange: onChange }, options.map(function (option) {
    return _react2.default.createElement('option', { key: option.id, value: option.value }, option.title);
  })), !isTextArea && !isSelect && _react2.default.createElement('input', {
    type: type,
    id: id,
    className: (0, _classnames2.default)('frm-Field_Item', {
      'frm-Field_Item-date': isDate,
      'frm-Field_Item-dateEdit': isDate && labelTop
    }),
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onFocus: function onFocus(el) {
      return updateLabelStyle(el);
    },
    onBlur: function onBlur(el) {
      return updateLabelStyle(el);
    },
    onInput: function onInput(el) {
      return updateLabelStyle(el);
    },
    onKeyUp: !isDate && function (el) {
      return updateLabelStyle(el);
    }
  }), label && _react2.default.createElement('p', {
    className: (0, _classnames2.default)('frm-Field_Label', {
      'frm-Field_Label-top': labelTop || !!isTextArea || !!isSelect
    })
  }, label));
};

exports.FormField = FormField;
FormField.defaultProps = {
  label: undefined,
  type: 'input',
  id: undefined,
  className: undefined
};

FormField.propTypes = {
  label: _propTypes2.default.string,
  type: _propTypes2.default.string,
  options: _propTypes2.default.array,
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  placeholder: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired
};